import { useRef } from 'react'
import { ViewPillNav, type ViewTab } from './ViewPillNav'
import { EventAttendanceMenu } from '../../components/EventAttendanceMenu'
import { useScrollEdges } from '../../hooks/useScrollEdges'
import { edgeMask } from '../../lib/edgeMask'
import type { EventInterestStatus } from '../../hooks/useEventInterest'

// Pills on the left, an icon-only RSVP button pinned on the right. The button
// never gives way: when the pills outgrow the space beside it they scroll
// horizontally behind it instead (the Afters pill is what tips a phone-width
// row over), with the clipped edge faded out so it reads as "more this way"
// rather than a hard cut. `data-no-swipe` keeps the page's tab-swipe gesture
// from eating the scroll, the same way the day tabs opt out.
export function ViewPillNavRow({
  view,
  onViewChange,
  interestStatus,
  interestLoading = false,
  onSetStatus,
  crewUnread = 0,
  showAfters = false,
}: {
  view: ViewTab
  onViewChange: (v: ViewTab) => void
  interestStatus: EventInterestStatus
  interestLoading?: boolean
  onSetStatus: (status: EventInterestStatus) => void
  crewUnread?: number
  showAfters?: boolean
}) {
  const scrollRef = useRef<HTMLDivElement>(null)
  const { overflowLeft, overflowRight } = useScrollEdges(scrollRef)
  const mask = edgeMask(overflowLeft, overflowRight)

  return (
    <div className="flex items-center gap-2 flex-nowrap">
      <div
        ref={scrollRef}
        data-testid="view-pill-nav"
        data-no-swipe
        className="min-w-0 flex-1 overflow-x-auto overflow-y-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        style={mask ? { maskImage: mask, WebkitMaskImage: mask } : undefined}
      >
        <ViewPillNav
          view={view}
          onViewChange={onViewChange}
          crewUnread={crewUnread}
          showAfters={showAfters}
        />
      </div>
      <div className="flex shrink-0 items-center">
        <EventAttendanceMenu
          variant="icon"
          status={interestStatus}
          loading={interestLoading}
          onSetStatus={onSetStatus}
        />
      </div>
    </div>
  )
}
